export enum OauthOption {
  Google = 'Google',
  Microsoft = 'Microsoft',
  Salesforce = 'Salesforce',
  Okta = 'Okta',
  EmailAndPassword = 'EmailAndPassword',
}
